export default __webpack_public_path__ + "table-dark.2c5eaaaa.svg";